export default __webpack_public_path__ + "static/Pattaya-image-e596413f394815fb07ffe0798ba26798.webp";